import { BRAND_DOCUMENT_MIME_TYPES, BRAND_LIMITS } from '@mg/shared';
import { ApiRequestError, actionErrorText } from '../../../lib/api';
import { DOCUMENT_BOX_COPY, FILE_CHECK_TEXT } from '../wizardCopy';

/**
 * The brand document's checks in the browser, before any upload (web.md §5.2). The server decides by
 * the file's bytes (a renamed file is refused there), so these only spare a pointless upload.
 */

/** The file picker's filter: the two extensions and the two types, as today's upload (EditWorkspaceForm). */
export const DOCUMENT_ACCEPT = ['.docx', '.pdf', ...BRAND_DOCUMENT_MIME_TYPES].join(',');

const EXTENSIONS = ['.docx', '.pdf'];

/** Why this file cannot be uploaded, in words; null when it can. */
export function documentFileProblem(file: Pick<File, 'name' | 'size'>): string | null {
  const name = file.name.toLowerCase();
  if (!EXTENSIONS.some((ext) => name.endsWith(ext))) return FILE_CHECK_TEXT.type;
  if (file.size > BRAND_LIMITS.uploadBytes) return FILE_CHECK_TEXT.size;
  return null;
}

/** "820 KB", "1.4 MB". */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** An upload the server refused: its own sentence (400, 429, 503), the size rule for a 413. */
export function uploadErrorText(err: unknown): string {
  if (err instanceof ApiRequestError && err.status === 413) return FILE_CHECK_TEXT.size;
  return actionErrorText(err, DOCUMENT_BOX_COPY.uploadFailed);
}

/** "Oct 30, 2026". */
export function shortDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
